import type { RouteLocationNormalizedGeneric } from 'vue-router'
import type { RouteMetaCustom } from './types'

export function isConsultationRoute(to: RouteLocationNormalizedGeneric): boolean {
  return to.matched.some((record) => (record.meta as RouteMetaCustom).consultation === true)
}
